import { TableCell } from "~/components/ui/table";
import { SearchEntityType } from "~/services/search";
import { ENTITY_TYPE_LABEL, entityIcon } from "./constants";

/** An entity type's icon and label, plain so it reads as the row's first field. */
export const EntityTypeCell = ({ entityType }: { entityType: SearchEntityType }) => (
  <TableCell>
    <span className="flex items-center gap-1.5">
      {entityIcon(entityType)}
      {ENTITY_TYPE_LABEL[entityType]}
    </span>
  </TableCell>
);
